import BookmakerSelectV8 from "../BookmakerSelectV8";

const KbvTiLeV8HeaderRight = ({
  newbieMode,
  onNewbieModeChange,
  bookmarkerExtend,
  onBookmakerExtendChange,
  bookmakerExtendOptions,
  small = false,
}) => (
  <div className="flex min-w-0 shrink-0 flex-wrap items-center justify-end gap-2 lg:flex-nowrap">
    <div className={`flex items-center gap-2 rounded-md bg-transparent px-1 ${small ? "h-6" : "h-8"}`}>
      <p className={`font-medium kbv-text-gray-dark ${small ? "text-[12px]" : "text-base"}`}>Newbie</p>
      <label className={`relative inline-block !mb-0 ${small ? "h-5 w-9" : "h-6 w-11"}`}>
        <input
          type="checkbox"
          checked={newbieMode}
          onChange={(event) => onNewbieModeChange(event.target.checked)}
          className="peer sr-only"
        />
        <span className="absolute inset-0 cursor-pointer rounded-full transition-colors duration-200 kbv-newbie-track" />
        <span className={`pointer-events-none absolute left-[2px] top-1/2 -translate-y-1/2 rounded-full bg-white transition-transform duration-200 ${small ? "h-4 w-4 peer-checked:translate-x-[16px]" : "h-5 w-5 peer-checked:translate-x-[18px]"} kbv-newbie-thumb`} />
      </label>
    </div>

    <div className="hidden md:block">
      <BookmakerSelectV8
        value={bookmarkerExtend}
        onChange={onBookmakerExtendChange}
        options={bookmakerExtendOptions}
      />
    </div>
  </div>
);

export default KbvTiLeV8HeaderRight;
